var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "VideoBg" }, [
    _c(
      "video",
      {
        ref: "video",
        attrs: { autoplay: "", loop: "", muted: "" },
        domProps: { muted: true }
      },
      _vm._l(_vm.sources, function(source) {
        return _c("source", {
          attrs: { src: source, type: _vm.getMediaType(source) }
        })
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "VideoBg__content" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }